import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppTokenHandler } from '../../common/app-token-handler';
import { environment } from '../../../environments/environment';
import { Global } from 'src/app/Global';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgxSpinnerService } from "ngx-spinner";

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DataService } from 'src/app/common/data.service';
enum Roles {
    Admin = 1,
    LocationSPOC = 2,
    Finance = 3

}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],

})

export class HomeComponent implements OnInit {

    // ***********************************Properties Declaration*******************************//
    UserName: string;
    IsAuthenticated: boolean;
    UserRole: string;
    UserImage: string;
    isCollapsed = true;
    // ************************************END Properties Declaration**************************//

    constructor(private route: Router, private appToken: AppTokenHandler,
        public _global: Global, private spinnerService: NgxSpinnerService, private data: DataService) {
    }
    menuitems: MenuItem[];
    useritems: MenuItem[];
    subitems: Array<{ label: string, icon: string, routerLink: string }> = [];

    ngOnInit() {
        this.spinnerService.show();
        const UserDetails = this.appToken.getLoginUserInfo();
        this._global.IsConsent = UserDetails.IsConsent;
        if (this._global.IsConsent === false) {
            document.getElementById('overlays').style.display = 'block';
        } else {
            document.getElementById('overlays').style.display = 'block';
        }
        if (UserDetails != null) {
            this.UserName = UserDetails.EmpName;
            this.UserRole = UserDetails.Roles;
            this.UserImage = UserDetails.UserImage;
        }
        this._global.IsAdmin = false;
        this._global.IsLocationSPOC = false;
        this._global.IsFinance = false;
        this._global.RolesList = this.appToken.GetRolesList();
        for (let index = 0; index < this._global.RolesList.length; index++) {
            if (this._global.RolesList[index] === Roles[Roles.Admin]) {
                this._global.IsAdmin = true;
                this._global.CurrentRole = 'Admin';
                this._global.IsLocationSPOC = false;
                this._global.IsFinance = false;
            } else if (this._global.RolesList[index] === Roles[Roles.LocationSPOC]) {
                this._global.IsLocationSPOC = true;
                this._global.IsFinance = false;
                this._global.CurrentRole = 'LocationSPOC';

            } else if (this._global.RolesList[index] === Roles[Roles.Finance]) {
                this._global.IsFinance = true;
                this._global.CurrentRole = 'Finance';
            }
        }
        this.spinnerService.hide();
    }

    createBookmark(event: Event) {
        event.stopPropagation();
        (window as any).createBookmark();
    }

    // logoutUser(event: Event) {
    //     event.stopPropagation();
    //     this.data.LogoutUser('Token/logout').subscribe(data => {
    //     }, (error) => {
    //     }, () => {
    //         this.appToken.clearSessionToken();
    //     });
    // }

    logoutUser(event: Event) {
        event.stopPropagation();
        this.appToken.clearSessionToken();
        this.data.LogoutUser('Token/logout').subscribe(data => {
        });
    }

    Login() {
        this.route.navigate(['/login']);
    }
}
